var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "667addf0c4290fe8411d06b253627a0204a56a90"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dubbot-react@dubbot-5f"] = {
  id: "667addf0c4290fe8411d06b253627a0204a56a90"
};